// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Zz-z","tooltipWrapper":"_z-z","icon":"aA-z","tooltip":"bA-z","content":"cA-z"};